import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

export interface LogRetentionSettingDto {
  id?: number;
  retentionDays: number;
  updatedBy?: number | null;
  updatedAt?: string | null;
}

@Injectable({providedIn: 'root'})
export class LogRetentionSettingService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/settings/log-retention';

  getSetting(): Observable<LogRetentionSettingDto> {
    return this.http.get<LogRetentionSettingDto>(this.apiUrl);
  }

  saveSetting(dto: LogRetentionSettingDto): Observable<LogRetentionSettingDto> {
    return this.http.put<LogRetentionSettingDto>(this.apiUrl, dto);
  }
}
